/* Problematic Tees: free-shipping meters + header rail (Option A "The Rail"). Vanilla, no deps.
   - Header rail [data-ship-rail] (snippets/ship-meter.liquid, variant rail): fill + tee marker + label follow the cart subtotal on EVERY cart change (pt:cart:updated from theme.js, fallback /cart.js).
   - Tee spin: rotation = scrollY / (document height - viewport height) * 360deg, one passive scroll listener, one requestAnimationFrame per frame, written to --rot on [data-tee-spin]. Reduced motion: no spin.
   - Tight state: html.is-compact when scrollY > 80, released under 40 (hysteresis). The header never hides and never changes the flow height.
   - Reached moment (partial to reached): fill 600ms, +560ms one cream sweep and one extra 360 turn of the tee, label crossfades (180ms out, swap, in).
   - Ticket: [data-signup] buttons (header ticket, menu line) scroll to the footer email field and focus it.
   - Drawer / cart page / PDP meters ([data-ship-meter]) are updated by render(). */
(function () {
  'use strict';

  /* ---- pure logic (no DOM): testable in Node via require() ---- */
  function stateFor(totalCents, thrCents) {
    var t = +totalCents || 0, h = +thrCents || 0;
    if (t <= 0) return 'empty';
    return t >= h ? 'reached' : 'partial';
  }
  function plainMoney(c, whole) {
    var v = c / 100;
    return '$' + (whole && v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  /* fmt(cents, whole) -> money string; whole=true drops trailing .00 */
  function stateText(totalCents, thrCents, fmt) {
    var f = typeof fmt === 'function' ? fmt : plainMoney;
    var t = +totalCents || 0, h = +thrCents || 0, st = stateFor(t, h);
    if (st === 'reached') return 'Free US shipping unlocked';
    if (st === 'partial') return f(h - t, false) + ' to go for free US shipping';
    return 'Free US shipping on orders ' + f(h, true) + '+';
  }
  /* degrees for the tee: scroll progress * 360, direct mapping */
  function teeRot(scrollY, maxScroll) {
    var y = +scrollY, m = +maxScroll;
    if (!(m > 0) || !(y > 0)) return 0;
    return Math.round(Math.min(1, y / m) * 3600) / 10;
  }
  var api = { stateFor: stateFor, stateText: stateText, teeRot: teeRot };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.PTShip = api;

  var d = document, W = window, root = d.documentElement;
  var mq = W.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  var cur = (W.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

  function money(c, whole) {
    var v = c / 100, n = whole && v % 1 === 0 ? 0 : 2;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, minimumFractionDigits: n, maximumFractionDigits: n }).format(v); }
    catch (e) { return '$' + v.toFixed(n); }
  }
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function fill(tpl, m) {
    return esc(tpl).replace(/\[remaining\]/g, '<b class="mono">' + m.rem + '</b>')
      .replace(/\[threshold\]/g, '<b class="mono">' + m.thr + '</b>')
      .replace(/\[flat\]/g, '<b class="mono">' + m.flat + '</b>')
      .replace(/\[extra\]/g, '<b class="mono">' + m.extra + '</b>');
  }
  function fillPlain(tpl, m) { return tpl.replace(/\[remaining\]/g, m.rem).replace(/\[threshold\]/g, m.thr); }

  /* ---- drawer / cart page / PDP meters ---- */
  function render(total) {
    [].forEach.call(d.querySelectorAll('[data-ship-meter]'), function (el) {
      var thr = +el.getAttribute('data-threshold') || 7000, rate = +el.getAttribute('data-rate') || 495, extra = +el.getAttribute('data-extra') || 240;
      var p = Math.max(0, Math.min(total / thr, 1));
      var st = total <= 0 ? '0' : (total >= thr ? 'full' : 'mid');
      var prev = el.getAttribute('data-state');
      var m = { rem: money(thr - total), thr: money(thr, 1), flat: money(rate), extra: money(extra) };
      el.style.setProperty('--p', p);
      el.setAttribute('data-state', st);
      el.setAttribute('data-total', total);
      var tally = el.querySelector('[data-ship-tally]');
      if (tally) { var gt = tally.getAttribute('data-gauge-' + st); tally.textContent = gt ? gt.replace(/\[remaining\]/g, m.rem).replace(/\[threshold\]/g, m.thr) : money(total) + ' / ' + m.thr; }
      [].forEach.call(el.querySelectorAll('[data-ship-text]'), function (t) {
        var html = fill(el.getAttribute('data-' + t.getAttribute('data-ship-text') + '-' + st) || '', m);
        if (t.innerHTML === html) return;
        if (reduced()) { t.innerHTML = html; return; }
        t.classList.add('is-swap');
        setTimeout(function () { t.innerHTML = html; t.classList.remove('is-swap'); }, 120);
      });
      if (st === 'full' && prev && prev !== 'full' && !reduced()) {
        el.classList.add('is-sheen');
        setTimeout(function () { el.classList.remove('is-sheen'); }, 700);
      }
    });
  }

  /* ---- header rail ---- */
  /* tight state: the lane stops short of the label, so give CSS the label's width (--lblw) */
  function measure() {
    if (!root.classList.contains('is-compact')) return;
    [].forEach.call(d.querySelectorAll('[data-ship-rail]'), function (el) {
      var lbl = el.querySelector('[data-rail-lbl]');
      if (lbl) el.style.setProperty('--lblw', Math.ceil(lbl.getBoundingClientRect().width) + 'px');
    });
  }
  function rails(total) {
    [].forEach.call(d.querySelectorAll('[data-ship-rail]'), function (el) {
      var thr = +el.getAttribute('data-threshold') || 7000;
      var st = total <= 0 ? '0' : (total >= thr ? 'full' : 'mid');
      var prev = el.getAttribute('data-state');
      var m = { rem: money(thr - total), thr: money(thr, 1) };
      el.style.setProperty('--p', Math.max(0, Math.min(total / thr, 1)));
      el.setAttribute('data-state', st);
      el.setAttribute('data-total', total);
      var lbl = el.querySelector('[data-rail-lbl]');
      if (lbl) {
        var texts = {}, changed = false;
        ['l', 'm', 's'].forEach(function (k) {
          var sp = lbl.querySelector('[data-r="' + k + '"]');
          if (!sp) return;
          texts[k] = fillPlain(el.getAttribute('data-' + k + '-' + st) || '', m);
          if (sp.textContent !== texts[k]) changed = true;
        });
        if (changed) {
          var swap = function () {
            ['l', 'm', 's'].forEach(function (k) { var sp = lbl.querySelector('[data-r="' + k + '"]'); if (sp && texts[k] != null) sp.textContent = texts[k]; });
            lbl.classList.remove('is-swap');
            measure();
          };
          clearTimeout(el._swapT);
          if (reduced()) swap();
          else { lbl.classList.add('is-swap'); el._swapT = setTimeout(swap, 180); }
        }
      }
      if (st === 'full' && prev && prev !== 'full' && !reduced()) {
        clearTimeout(el._sweepT); clearTimeout(el._sweepEnd);
        el.classList.remove('is-sweep', 'is-kick');
        el._sweepT = setTimeout(function () { void el.offsetWidth; el.classList.add('is-sweep', 'is-kick'); }, 560);
        el._sweepEnd = setTimeout(function () { el.classList.remove('is-sweep', 'is-kick'); }, 560 + 950);
      }
    });
  }

  /* ---- cart sync: the theme's pt:cart:updated (every add / change / remove, drawer or page), fallback /cart.js ---- */
  function apply(total) { render(total); rails(total); }
  function cartUrl() { return ((W.PT && W.PT.routes && W.PT.routes.cart) || '/cart') + '.js'; }
  function pull() {
    return fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.total_price === 'number') apply(c.total_price); })
      .catch(function () { /* offline: keep the server-rendered state */ });
  }
  function onCart(e) {
    if (e && e.detail && typeof e.detail.total_price === 'number') apply(e.detail.total_price);
    else pull();
  }
  d.addEventListener('pt:cart:updated', onCart);
  d.addEventListener('cart:updated', onCart);
  d.addEventListener('cart:refresh', onCart);
  W.addEventListener('pageshow', function (e) { if (e.persisted) pull(); });
  var hiddenAt = 0;
  d.addEventListener('visibilitychange', function () {
    if (d.hidden) { hiddenAt = Date.now(); return; }
    if (hiddenAt && Date.now() - hiddenAt > 5000) pull();
  });

  /* ---- scroll: tight state with hysteresis, tee spin = scroll progress * 360deg (one rAF per frame) ---- */
  var tight = root.classList.contains('is-compact'), tick = false;
  var spins = [].slice.call(d.querySelectorAll('[data-tee-spin]'));
  function frame() {
    tick = false;
    var y = W.scrollY || W.pageYOffset || 0;
    if (tight) { tight = false; root.classList.remove('is-compact'); }
    if (spins.length && !reduced()) {
      var deg = teeRot(y, root.scrollHeight - W.innerHeight) + 'deg';
      for (var i = 0; i < spins.length; i++) spins[i].style.setProperty('--rot', deg);
    }
  }
  function queue() { if (!tick) { tick = true; requestAnimationFrame(frame); } }
  W.addEventListener('scroll', queue, { passive: true });
  W.addEventListener('resize', function () { queue(); measure(); }, { passive: true });
  W.addEventListener('load', queue);
  frame();
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(measure);

  /* ---- ticket: scroll to the footer sign-up field and focus it (nothing is copied) ---- */
  function goSignup() {
    if (W.PTSignup) { W.PTSignup.open(d.activeElement); return; }
    var input = d.getElementById('foot-email');
    if (!input) return;
    var nav = d.getElementById('mobile-nav'), tog = d.querySelector('[data-menu-toggle]');
    if (nav && !nav.hidden && tog) tog.click();
    setTimeout(function () {
      var r = reduced();
      try { input.scrollIntoView({ behavior: r ? 'auto' : 'smooth', block: 'center' }); } catch (e) { input.scrollIntoView(); }
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    }, 0);
  }
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-signup]')) goSignup();
  });
})();
